import { GetRandomEnum } from 'motw_core/Utils/EnumUtils';

// Commented out values are bad choices for background images
export enum ETexture {
	'3px-tile',
	'45-degree-fabric-dark',
	'45-degree-fabric-light',
	'60-lines',
	'absurdity',
	'ag-square',
	'always-grey',
	'arabesque',
	'arab-tile',
	'arches',
	'argyle',
	'asfalt',
	'asfalt-dark',
	'asfalt-light',
	'assault', // meh
	'axiom-pattern',
	'az-subtle',
	'back-pattern',
	'batthern',
	'bedge-grunge',
	'beige-paper',
	'billie-holiday',
	'binding-dark',
	'binding-light',
	'black-felt',
	'black-linen',
	'black-linen-2',
	'black-lozenge',
	'black-mamba',
	'black-orchid',
	'black-paper',
	'black-scales',
	'black-thread',
	'black-thread-light',
	'black-twill',
	'blizzard',
	'blu-stripes',
	'bo-play',
	'brick-wall',
	'brick-wall-dark',
	'bright-squares',
	'brilliant', // preferred
	'broken-noise',
	'brushed-alum',
	'brushed-alum-dark',
	'buried',
	'candyhole',
	'carbon-fibre',
	'carbon-fibre-big',
	'carbon-fibre-v2',
	'cardboard',
	'cardboard-1',
	'cardboard-flat',
	'cartographer',
	'checkered-light-emboss',
	'checkered-light-emboss-backup',
	'checkered-pattern',
	'church',
	'circles',
	'classy-fabric',
	'clean-gray-paper',
	'clean-textile',
	'climpek',
	'cloth-alike',
	'concrete-wall',
	'concrete-wall-2', // preferred
	'concrete-wall-3',
	'connected',
	'cork-1',
	'corrugation',
	'cracks-1',
	'cream-dust',
	'cream-paper',
	'cream-pixels',
	'crisp-paper-ruffles',
	'crissxcross',
	'cross-scratches',
	'cross-stripes',
	'crossword',
	'cubes',
	'cutcube',
	'dark-brick-wall',
	'dark-circles',
	'dark-denim', // preferred
	'dark-denim-3',
	'dark-dot',
	'dark-dotted-2',
	'dark-exa',
	'dark-fish-skin',
	'dark-geometric',
	'dark-leather',
	'dark-matter',
	'dark-mosaic',
	'dark-stripes',
	'dark-stripes-light',
	'dark-tire',
	'dark-wall',
	'dark-wood',
	'darth-stripe',
	'debut-dark',
	'debut-light',
	'diagmonds',
	'diagmonds-light', // preferred
	'diagonales-decalees',
	'diagonal-noise',
	'diagonal-striped-brick',
	'diagonal-waves',
	'diamond-eyes',
	'diamonds-are-forever',
	'diamond-upholstery',
	'dimension',
	'dimenson',
	'dirty-old-black-shirt',
	'dotnoise-light-grey',
	'double-lined',
	'dust',
	'ecailles',
	'egg-shell',
	'elastoplast',
	'elegant-grid',
	'embossed-paper',
	'escheresque',
	'escheresque-dark',
	'exclusive-paper',
	'fabric-1',
	'fabric-1-dark',
	'fabric-1-dark-transparenttextures',
	'fabric-1-light',
	'fabric-1-light-transparenttextures',
	'fabric-of-squares',
	'fabric-plaid',
	'fake-brick',
	'fake-luxury',
	'fancy-deboss',
	'farmer',
	'felt',
	'first-aid-kit',
	'flowers',
	'flower-trail',
	'foggy-birds',
	'food',
	'french-stucco',
	'fresh-snow',
	'geometry',
	'gold-scale',
	'gplay',
	'gradient-squares',
	'graphcoders-lil-fiber',
	'graphy',
	'graphy-dark',
	'gray-floral',
	'gray-lines',
	'gray-sand',
	'gray-sand-transparenttextures',
	'green-cup',
	'green-dust-and-scratches', // preferred
	'green-fibers',
	'green-gobbler',
	'grey-jean',
	'grey-sandbag',
	'grey-washed-wall',
	'greyzz',
	'grid',
	'grid-me',
	'grid-noise',
	'grilled-noise',
	'groovepaper',
	'grunge-wall',
	'gun-metal',
	'handmadepaper',
	'handmade-paper',
	'hexabump',
	'hexellence',
	'hixs-evolution',
	'hoffman',
	'honey-im-subtle',
	'ice-age',
	'inflicted',
	'inspiration-geometry', // preferred
	'iron-grip',
	'kinda-jean',
	'knitted-netting',
	'knitted-sweater',
	'kuji',
	'large-leather',
	'leather',
	'leather-1',
	'leather-1-1',
	'leather-1-transparenttextures',
	'light-aluminum',
	'light-gray',
	'light-grey-floral-motif',
	'light-honeycomb',
	'light-honeycomb-dark',
	'light-mesh',
	'light-paper-fibers',
	'light-sketch',
	'light-toast',
	'light-wool', // preferred
	'lined-paper',
	'lined-paper-2',
	'little-knobs', // preferred
	'little-pluses',
	'little-triangles',
	'low-contrast-linen',
	'lyonnette',
	'maze-black',
	'maze-white',
	'mbossed',
	'medic-packaging-foil',
	'merely-cubed',
	'micro-carbon',
	'micro-carbon-transparenttextures', // preferred
	'mirrored-squares',
	'mocha-grunge',
	'mooning',
	'moulin',
	'my-little-plaid',
	'my-little-plaid-dark',
	'nami',
	'nasty-fabric',
	'natural-paper',
	'navy',
	'nice-snow',
	'nistri',
	'noise-lines',
	'noise-pattern-with-subtle-cross-lines',
	'noisy',
	'noisy-grid',
	'noisy-net',
	'norwegian-rose',
	'notebook',
	'notebook-dark',
	'office',
	'old-husks',
	'old-map',
	'old-mathematics',
	'old-moon',
	'old-wall',
	'otis-redding',
	'outlets',
	'p1',
	'p2',
	'p4', // preferred
	'p5',
	'p6',
	'padded',
	'padded-light',
	'paper',
	'paper-1',
	'paper-2',
	'paper-3',
	'paper-fibers',
	'paven',
	'perforated-white-leather',
	'pineapple-cut',
	'pinstripe',
	'pinstripe-dark',
	'pinstriped-suit',
	'pinstripe-light',
	'pixel-weave',
	'polaroid',
	'polonez-pattern',
	'polyester-lite',
	'pool-table',
	'project-paper',
	'ps-neutral',
	'psychedelic',
	'purty-wood',
	'pw-pattern',
	'pyramid',
	'quilt',
	'random-grey-variations',
	'ravenna',
	'real-carbon-fibre',
	'rebel',
	'redox-01',
	'redox-02',
	'reticular-tissue',
	'retina-dust',
	'retina-wood',
	'retro-intro',
	'rice-paper',
	'rice-paper-2',
	'rice-paper-3',
	// 'rip-jobs',
	'robots',
	'rockywall',
	'rocky-wall',
	'rough-cloth',
	'rough-cloth-light',
	'rough-diagonal',
	'rubber-grip',
	'sandpaper',
	'satin-weave',
	'scribble-light',
	'shattered',
	'shattered-dark',
	'shine-caro',
	'shine-dotted',
	'silver-scales',
	'simple-dashed',
	'simple-horizontal-light',
	'skeletal-weave',
	'skewed-print',
	'skin-side-up',
	'skulls',
	'slash-it',
	'small-crackle-bright',
	'small-crosses',
	'smooth-wall',
	'smooth-wall-1',
	'smooth-wall-dark',
	'smooth-wall-light',
	'sneaker-mesh-fabric',
	'snow',
	'soft-circle-scales',
	'soft-kill',
	'soft-pad',
	'soft-wallpaper',
	'solid',
	'sos',
	'sprinkles',
	'squairy',
	'squared-metal',
	'squares',
	'stacked-circles',
	'stardust',
	'starring',
	'stitched-wool',
	'strange-bullseyes',
	'straws',
	'stressed-linen',
	'stucco',
	'subtle-carbon',
	'subtle-dark-vertical',
	'subtle-dots',
	'subtle-freckles',
	'subtle-grey',
	'subtle-grunge',
	'subtlenet',
	'subtle-stripes',
	'subtle-surface',
	'subtle-white-feathers',
	'subtle-zebra-3d',
	'swirl',
	'tactile-noise',
	'tactile-noise-dark',
	'tactile-noise-dark-transparenttextures',
	'tactile-noise-light',
	'tactile-noise-light-transparenttextures',
	'tapestry',
	'tasky',
	'tex2res1',
	'tex2res2',
	'tex2res3',
	'tex2res4',
	'tex2res5',
	'textured-paper',
	'textured-stripes',
	'texturetastic-gray',
	'ticks',
	'tileable-wood',
	'tileable-wood-colored',
	'tiny-grid',
	'translucent-fibres',
	'transparent-square-tiles',
	'tree-bark',
	'triangles',
	'triangles-2',
	'triangular',
	'tweed',
	'twinkle-twinkle',
	'txture',
	'type',
	'use-your-illusion',
	'vaio',
	'vertical-cloth',
	'vichy',
	'vintage-speckles',
	'wall-4-light',
	'washi',
	'wavecut',
	'wave-grid',
	'weave', // meh
	'wet-snow',
	'white-bed-sheet',
	'white-brick-wall',
	'white-brushed',
	'white-carbon',
	'white-carbonfiber',
	'white-carbon-transparenttextures',
	'white-diamond',
	'white-diamond-dark',
	'white-leather',
	'white-linen',
	'white-paperboard',
	'white-plaster',
	'white-sand',
	'white-texture',
	'white-tiles',
	'white-wall',
	'white-wall-3',
	'white-wall-3-2',
	'white-wave',
	'whitey',
	'wide-rectangles',
	'wild-flowers',
	'wild-oliva',
	'wine-cork',
	'witewall-3',
	'wood', // preferred
	'wood-pattern',
	'worn-dots',
	'woven',
	'woven-light',
	'xv', // preferred
	'zig-zag'
}

export const GetRandomETexture = () =>
	GetRandomEnum(ETexture);
